/**
 * @file HomeFooterView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import {  Button, Stack } from "@mui/material";
import "./../Footer.css";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { ThemeProvider } from "@mui/material/styles";
import { FooterEmailTheme, FooterHyperLinkTheme } from "../FooterTheme";
import React from "react";
import { AppName, AppVersion, HelpEmail } from "../../utils/AppConstant";

/**
 * A function component for HomeFooterView
 * @returns 
 */
export function HomeFooterView(props) {

      /**
       * Handles privacy
       */
      const showPrivacyNotice = () => {
        props.showPrivacyNotice();  /* eslint-disable-line */
      };

      /**
       * Handles terms of use
       */
      const showTermsOfUse = () => {
        props.showTermsOfUse();  /* eslint-disable-line */
      };      

  return (
      <div className="HomeFooter">
            <div className="FooterSectionUp">
              <img src="/../footer-boston-logo.svg" className="HeaderLogo" alt="" />
              <ThemeProvider theme={FooterEmailTheme} >
                <Button className="BostonLabelEmail" onClick={() => {
                  window.location = `mailto:${HelpEmail}` as any
                  }
                }><u>{HelpEmail}</u></Button>
                </ThemeProvider>
            </div>
          <Divider className="Divider" />
          <div className="FooterSectionDown">
              <Stack sx={{ flexDirection: { xs: "column", md: "row"} }}>
              <div className="FooterSectionDown-Left" >
                <Typography  sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "1",
                        WebkitBoxOrient: "vertical",
                    }} className="FooterDescirption">
                    {AppName} Version {AppVersion}, © Copyright 2023 Boston Scientific, All rights reserved.
                  </Typography>
              </div>
              <div className="FooterSectionDown-Right">
                <Stack  direction="row" spacing={2}   justifyContent="flex-end">
                  <ThemeProvider theme={FooterHyperLinkTheme}>
                    <Button id="TermsOfUse" className="FooterLink" onClick={showTermsOfUse}><u>Terms of Use</u> </Button>
                  </ThemeProvider>
                  <ThemeProvider theme={FooterHyperLinkTheme}>
                    <Button id="PrivacyPolicy" className="FooterLink" onClick={showPrivacyNotice}><u>Privacy Policy</u></Button>
                  </ThemeProvider>
                  <ThemeProvider theme={FooterHyperLinkTheme}>
                    <Button href="https://www.bostonscientific.com/elabeling" className="FooterLink" target="_blank"><u>Indication of Use</u></Button>
                  </ThemeProvider>
                </Stack >
              </div>
            </Stack>
          </div>
      </div>
  );
}
